import { Injectable, effect, inject } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from '../Services/translation.service';

@Injectable({ providedIn: 'root' })
export class TranslatePaginatorIntlStrategy extends MatPaginatorIntl {
  private readonly _translate = inject(TranslateService);
  private readonly _translation = inject(TranslationService);

  override getRangeLabel = (page: number, pageSize: number, length: number): string =>
    this._buildRangeLabel(page, pageSize, length);

  constructor() {
    super();
    this._registerLabelSync();
  }

  private _registerLabelSync(): void {
    effect(() => {
      this._translation.currentLanguage();
      this._applyLabels();
    });
  }

  private _applyLabels(): void {
    this.itemsPerPageLabel = this._translate.instant('shared.paginator.items_per_page');
    this.nextPageLabel = this._translate.instant('shared.paginator.next_page');
    this.previousPageLabel = this._translate.instant('shared.paginator.previous_page');
    this.firstPageLabel = this._translate.instant('shared.paginator.first_page');
    this.lastPageLabel = this._translate.instant('shared.paginator.last_page');
    this.changes.next();
  }

  private _buildRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0 || pageSize === 0) {
      return this._translate.instant('shared.paginator.range_empty', { length });
    }

    const clampedLength = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex =
      startIndex < clampedLength ? Math.min(startIndex + pageSize, clampedLength) : startIndex + pageSize;

    return this._translate.instant('shared.paginator.range', {
      start: startIndex + 1,
      end: endIndex,
      length: clampedLength,
    });
  }
}
